import io from "socket.io-client";
import { baseUrl } from "./AsianExchangeSrc/api/axios";
import store from "./AsianExchangeSrc/redux/store";
import {
  setMatchesLoading,
  updateMatches,
  setMatchesError,
} from "./AsianExchangeSrc/redux/slices/matchSlice";
import {
  setMarketOddsLoading,
  setMarketOddsData,
  setMarketOddsError,
} from "./AsianExchangeSrc/redux/slices/fullmarketSlice";
import {
  setBookmakerData,
  setBookmakerError,
  setBookmakerLoading,
} from "./AsianExchangeSrc/redux/slices/bookmakerSlice";
import { setUserData } from "./AsianExchangeSrc/redux/slices/userSlice";
import {
  updateProfileData,
  addLatestBet,
} from "./AsianExchangeSrc/redux/slices/accountSlice";
import {
  setFancyOddsData,
  setFancyOddsError,
  setFancyOddsLoading,
} from "./AsianExchangeSrc/redux/slices/fancySlice";
// import {
//   setHorseOddsLoading,
//   setHorseOddsData,
//   setHorseOddsError,
// } from "./AsianExchangeSrc/redux/slices/horseOddsSlice"; // New slice
// import {
//   setGreyhoundOddsLoading,
//   setGreyhoundOddsData,
//   setGreyhoundOddsError,
// } from "./AsianExchangeSrc/redux/slices/greyhoundOddsSlice"; // New slice
import {
  updateHorseMarket,
  updateHorseSlice,
} from "./AsianExchangeSrc/redux/slices/horseSlice";
import {
  updateGreyhoundMarket,
  updateGreyhoundSlice,
} from "./AsianExchangeSrc/redux/slices/greyhoundSlice";
import { toast } from "react-toastify";



const socket = io(baseUrl, {
  auth: {
    token: store.getState().user.token || "",
  },
  reconnection: true,
  transports: ["websocket"],
});

socket.on("connect", () => {
  // console.log("Socket.io connected successfully");
});

socket.on("connect_error", (error) => {
  console.error("Connection error:", error.message);
  store.dispatch(setMatchesError({ sport: "all", error: error.message }));
  store.dispatch(setMarketOddsError(error.message));
  // store.dispatch(setHorseOddsError(error.message)); // Why? not defined?
  // store.dispatch(setGreyhoundOddsError(error.message)); // Why? not defined?
});

// Set user online/offline status
export const setUserOnline = (userId) => {
  socket.emit("userOnline", { currentUserId: userId });
};

export const setUserOffline = (userId) => {
  socket.emit("userOffline", { currentUserId: userId });
};

// Subscription for match data
export const subscribeToMatchData = ({
  eventId,
  eventType,
  sport: initialSport = "unknown",
}) => {
  store.dispatch(setMatchesLoading({ sport: initialSport }));

  socket.emit("subscribeToMatches", { eventId, eventType });

  socket.on("matchUpdate", (data) => {
    const sportFromData = data.sport || initialSport;
    if (data.matches) {
      store.dispatch(
        updateMatches({
          sport: sportFromData,
          data: { data: data.matches || []}, 
        })
      );
    }
  });

  socket.on("error", (error) => {
    store.dispatch(
      setMatchesError({ sport: initialSport, error: error.message })
    );
  });

  return () => {
    socket.off("matchUpdate");
    socket.off("error");
    socket.emit("unsubscribeFromMatches", { eventId });
  };
};

// Subscription for horse matches data
export const subscribeToHorseMatchesData = () => {
  // store.dispatch(setMatchesLoading({ sport: "horse" }));

  socket.emit("subscribeToHourseMatches");

  socket.on("horseMatchesUpdate", (data) => {
    if (data.status && data.data) {
      store.dispatch(updateHorseSlice({ horseRaceList: data?.data?.t1 }));
    } else {
      // store.dispatch(
      //   setMatchesError({ sport: "horse", error: data.message || "No data available" })
      // );
    }
  });

  socket.on("error", (error) => {
    store.dispatch(setMatchesError({ sport: "horse", error: error.message }));
  });

  return () => {
    socket.off("hourseMatchesUpdate");
    socket.off("error");
  };
};

// Subscription for greyhound matches data
export const subscribeToGreyhoundMatchesData = () => {
  // store.dispatch(setMatchesLoading({ sport: "greyhound" }));
  socket.emit("subscribeToGreyhoundMatches");

  socket.on("greyhoundMatchesUpdate", (data) => {
    if (data.status && data.data) {
      store.dispatch(
        updateGreyhoundSlice({ greyhoundRaceList: data?.data?.t1 })
      );
    } else {
      store.dispatch(
        setMatchesError({
          sport: "greyhound",
          error: data.message || "No data available",
        })
      );
    }
  });

  socket.on("error", (error) => {
    store.dispatch(
      setMatchesError({ sport: "greyhound", error: error.message })
    );
  });

  return () => {
    socket.off("GreyhoundMatchesUpdate");
    socket.off("error");
  };
};

// Subscription for market odds data
export const subscribeToMarketOddsData = ({
  eventId,
  eventType,
  competitionId,
  matchId,
  marketId,
  sport: initialSport = "unknown",
}) => {
  store.dispatch(setMarketOddsLoading());

  socket.emit("subscribeToMarketOdds", {
    eventId,
    eventType,
    competitionId,
    matchId,
    marketId,
  });

  socket.on("marketOddsUpdate", (data) => {
    const sportFromData = data.sport || initialSport;
    if (data.marketOdds) {
      store.dispatch(
        setMarketOddsData({
          data: { data: data.marketOdds },
          sport: sportFromData,
        })
      );
    }
  });

  socket.on("error", (error) => {
    console.error("Market odds error:", error.message);
    store.dispatch(setMarketOddsError(error.message));
  });

  return () => {
    socket.off("marketOddsUpdate");
    socket.off("error");
    socket.emit("unsubscribeFromMarketOdds", { eventId, marketId });
  };
};

// Subscription for horse odds data
export const subscribeToHourseOddsData = ({
  eventId,
  eventType,
  gmid,
  // sport: initialSport = "horse", // Why?
}) => {
  // store.dispatch(setHorseOddsLoading());

  socket.emit("subscribeToHourseOdds", { eventId, eventType, gmid });

  socket.on("horseOddsUpdate", (data) => {
    // const sportFromData = data.sport || initialSport;

    if (data.horseOdds) {
      store.dispatch(
        updateHorseMarket({
          gmid: data?.horseOdds?.data[0].gmid,
          odds: data?.horseOdds?.data,
        })
      );
    } else {
      // store.dispatch(
      //   setHorseOddsError(data.message || "No horse odds data available")
      // );
    }
  });

  socket.on("error", (error) => {
    console.error("Horse odds error:", error.message);
    // store.dispatch(setHorseOddsError(error.message)); // Why? 'setHorseOddsError' is not defined ?
  });

  return () => {
    socket.off("horseOddsUpdate");
    socket.off("error");
    socket.emit("unsubscribeFromHourseOdds", { eventId, gmid });
  };
};

// Subscription for greyhound odds data
export const subscribeToGreyHoundOddsData = ({
  eventId,
  eventType,
  gmid,
  // sport: initialSport = "greyhound", // Why? 'initialSport' is assigned a value but never used
}) => {
  // store.dispatch(setGreyhoundOddsLoading());

  socket.emit("subscribeToGreyHoundOdds", { eventId, eventType, gmid });

  socket.on("greyhoundOddsUpdate", (data) => {
    if (data.greyhoundOdds) {
      store.dispatch(
        updateGreyhoundMarket({
          gmid: data?.greyhoundOdds?.data[0].gmid,
          odds: data?.greyhoundOdds?.data,
        })
      );
    } else {
      // store.dispatch(
      //   setGreyhoundOddsError(data.message || "No greyhound odds data available")
      // );
    }
  });

  socket.on("error", (error) => {
    console.error("Greyhound odds error:", error.message);
    // store.dispatch(setGreyhoundOddsError(error.message)); // Why? setGreyhoundOddsError is not defined
  });

  return () => {
    socket.off("greyhoundOddsUpdate");
    socket.off("error");
    socket.emit("unsubscribeFromGreyHoundOdds", { eventId, gmid });
  };
};

// Subscription for bookmaker data
export const subscribeToBookmakerData = ({
  eventId,
  eventType,
  competitionId,
  sport: initialSport = "unknown",
}) => {
  store.dispatch(setBookmakerLoading());

  socket.emit("subscribeToBookmaker", { eventId, eventType, competitionId });

  socket.on("bookmakerUpdate", (data) => {
    const sportFromData = data.sport || initialSport;
    if (data.bookmakerOdds) {
      store.dispatch(
        setBookmakerData({ data: data.bookmakerOdds, sport: sportFromData })
      );
    }
  });

  socket.on("error", (error) => {
    store.dispatch(setBookmakerError(error.message));
  });

  return () => {
    socket.off("bookmakerUpdate");
    socket.off("error");
    socket.emit("unsubscribeFromBookmaker", { eventId });
  };
};

// Subscription for fancy odds data
export const subscribeToFancyOddsData = ({
  eventId,
  eventType,
  competitionId,
  sport: initialSport = "unknown",
}) => {
  store.dispatch(setFancyOddsLoading());

  socket.emit("subscribeToFancyOdds", { eventId, eventType, competitionId });

  socket.on("fancyOddsUpdate", (data) => {
    const sportFromData = data.sport || initialSport;
    if (data.fancyOdds) {
      store.dispatch(
        setFancyOddsData({ data: data.fancyOdds, sport: sportFromData })
      );
    }
  });

  socket.on("error", (error) => {
    store.dispatch(setFancyOddsError(error.message));
  });

  return () => {
    socket.off("fancyOddsUpdate");
    socket.off("error");
    socket.emit("unsubscribeFromFancyOdds", { eventId });
  };
};

// Subscription for profile room
export const subscribeToJoinProfileRoom = (currentUserId) => {
  socket.emit("joinProfileRoom", currentUserId);

  socket.on("ProfileUpdated", (data) => {
    if (data) {
      store.dispatch(setUserData(data));
      store.dispatch(updateProfileData(data));
    }
  });

  socket.on("error", (error) => {
    console.error(error);
  });

  return () => {
    socket.off("ProfileUpdated");
    socket.off("error");
    socket.emit("profile_disconnect");
  };
};

// Place bet
export const placeBet = async (betData) => {
  const { minBet, maxBet } = store.getState()?.betSettingsSlice?.betSettings || {};
  const siteId = store.getState()?.site?.siteDetails?._id || {};
  if (!betData?.isCashout) {
    if (minBet !== undefined && betData?.stake < minBet) {
        toast.error(`Bet amount must be at least ${minBet}`);
        return Promise.reject(new Error(`Bet amount must be at least ${minBet}`));
      }
      if (maxBet !== undefined && betData?.stake > maxBet) {
        toast.error(`Bet amount cannot exceed ${maxBet}`);
        return Promise.reject(new Error(`Bet amount cannot exceed ${maxBet}`));
      }
  }
  const _id = localStorage?.getItem("userId") || "";
  return new Promise((resolve, reject) => {
    socket.emit("placeBet", { ...betData, userId: _id,siteId:siteId }, (response) => {
      if (response.statusCode === 200) {
        store.dispatch(addLatestBet(betData));
      }
      if (response) {
        resolve(response);
      } else {
        console.error("Bet placement failed:", response.message);
        resolve(response);
      }
    });
    socket.on("error", (error) => {
      console.error("Socket error:", error.message);
      reject(new Error("Socket error: " + error.message));
    });
  }).finally(() => {
    socket.off("error");
  });
};

// Unsubscribe functions
export const generatePresignedUrlFromS3Url = (s3Url) => {
  return new Promise((resolve, reject) => {
    socket.emit("generatePresignedUrlFromS3Url", s3Url, (response) => {
      if (response.status === "success") {
        resolve(response.data); // Resolve with { url, key }
      } else {
        console.error("Failed to generate presigned URL:", response.message);
        reject(new Error(response.message)); // Reject with error message
      }
    });
  });
};
export const unsubscribeFromMatches = (eventId) => {
  socket.emit("unsubscribeFromMatches", { eventId });
};

export const unsubscribeFromMarketOdds = (eventId, marketId) => {
  socket.emit("unsubscribeFromMarketOdds", { eventId, marketId });
};

export const unsubscribeFromBookmaker = (eventId) => {
  socket.emit("unsubscribeFromBookmaker", { eventId });
};

export const unsubscribeFromFancyOdds = (eventId) => {
  socket.emit("unsubscribeFromFancyOdds", { eventId });
};

export const unsubscribeFromHourseOdds = (gmid) => {
  socket.emit("unsubscribeFromHourseOdds", { gmid });
};

export const unsubscribeFromGreyHoundOdds = (gmid) => {
  socket.emit("unsubscribeFromGreyHoundOdds", { gmid });
};

// socket.on("statusUpdated", ({ userId, isOnline }) => { // Why? is it required?
//   // console.log(`User ${userId} is ${isOnline ? "online" : "offline"}`);
// });

export default socket;
